var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.count > 0)?_c('v-badge',{attrs:{"color":"red","content":_vm.count}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }